import React, { useEffect } from 'react';
import Radioaizer from 'Global/Components/CommonComponents/Radioaizer/Radioaizer';
import { Apartment } from '@mui/icons-material';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import {
  Avatar,
  Card,
  LinearProgress,
  Stack,
} from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import { useAtom } from 'jotai';
import { selectedTurnItem } from '../../shared/selected.turn.items';
import { selectedDoctorAtom } from '../../shared/selected.doctor';
import { specialityServices } from '../../shared/speciality.service';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import { seletedDepartmentId } from '../../shared/selected.department.ids';

const Doctors = ({ doctors, controlBtn_ref, setSteps }) => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop

  const [SelectedTurn] = useAtom(selectedTurnItem);
  const [selectedDoctor, setSelectedDoctor] = useAtom(
    selectedDoctorAtom
  );
  const [, setSpecialityService] = useAtom(
    specialityServices
  );

  const [departmentIds] = useAtom(seletedDepartmentId);

  const isUnit =
    doctors &&
    doctors[0]?.doctor?.speciality === null &&
    doctors[0]?.doctor?.familyDoctor === null;

  useEffect(() => {
    setSelectedDoctor();
    setSpecialityService();
  }, []);

  // console.log('doctorsdoctors-->', doctors);

  useEffect(() => {
    if (selectedDoctor) {
      controlBtn_ref.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [selectedDoctor]);

  useEffect(() => {
    if (doctors?.length === 1) {
      if (departmentIds) {
        setSelectedDoctor(departmentIds[0]);
        setSteps((steps) => steps + 1);
      } else {
        setSelectedDoctor(doctors[0]);
        setSteps((steps) => steps + 1);
      }
    }
  }, [departmentIds, doctors]);

  const DoctorSelectButton = (props) => {
    return (
      <React.Fragment>
        <Card
          sx={{
            p: '1em',
            cursor: 'pointer',
            border:
              selectedDoctor?.doctor?.id ===
                props?.doctor?.doctor?.id ||
              (departmentIds &&
                selectedDoctor?.Id ===
                  departmentIds[props.index]?.Id)
                ? `3px solid ${themeColors.ColorPrimary}`
                : `1px solid ${themeColors.ColorPrimary}`,
            transition: 'all .3 ease',
            backgroundColor: `${themeColors.ColorSecondary}`,
          }}
        >
          <Stack gap=".5em" alignItems="center">
            {!isUnit ? (
              props?.doctor?.doctor?.imageArrayContent
                ?.image?.length === 0 ? (
                <Avatar
                  sx={{
                    color: themeColors.ColorSecondary,
                    backgroundColor:
                      themeColors.ColorPrimary,
                    width: '70px',
                    height: '70px',
                  }}
                />
              ) : (
                <img
                  src={
                    props?.doctor?.doctor?.imageArrayContent
                      ? `data:image/png;base64,${props?.doctor?.doctor?.imageArrayContent.image}`
                      : ''
                  }
                  alt={`${ArabicToPersian(
                    props?.doctor?.doctor?.nameDoctor
                  )}  ${ArabicToPersian(
                    props?.doctor?.doctor?.familyDoctor
                  )}`}
                  loading="..."
                  width={70}
                  height={70}
                  style={{ borderRadius: '100%' }}
                />
              )
            ) : (
              <Apartment
                sx={{
                  fontSize: '2.5em',
                  color: themeColors.ColorPrimary,
                }}
              />
            )}

            <p>{`${ArabicToPersian(
              props?.doctor?.doctor?.nameDoctor
            )}  ${
              props?.doctor?.doctor?.familyDoctor
                ? ArabicToPersian(
                    props?.doctor?.doctor?.familyDoctor
                  )
                : ''
            }`}</p>
            <p>{`${
              props?.doctor?.doctor?.speciality?.Name
                ? ArabicToPersian(
                    props?.doctor?.doctor?.speciality?.Name
                  )
                : ''
            }`}</p>
            <p>{`${ArabicToPersian(
              SelectedTurn?.label !==
                ArabicToPersian(
                  props?.doctor?.doctor?.speciality?.Name
                )
                ? SelectedTurn?.label
                : ''
            )}`}</p>
          </Stack>
        </Card>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {doctors ? (
        <Radioaizer
          elements={doctors?.map((doctor, index) => (
            <DoctorSelectButton
              doctor={doctor}
              index={index}
            />
          ))}
          onSelectFunction={(val) => {
            if (departmentIds) {
              setSelectedDoctor(departmentIds[val]);
            } else {
              setSelectedDoctor(doctors[val]);
            }
          }}
          justPassSelect={true}
          direction={screenWidth > 1024 ? 'grid' : 'column'}
          rows={screenWidth > 1024 && '1fr 1fr'}
          cols={screenWidth > 1024 && '1fr'}
        />
      ) : (
        <LinearProgress />
      )}
    </React.Fragment>
  );
};

export default Doctors;
